export const toDateInput = (v?: string | null): string => (v ? String(v).slice(0, 10) : '');
export const fmtDate = (v?: string | null): string => (v ? String(v).slice(0, 10) : '—');
export const fmtMoney = (v?: number | null): string =>
  v == null || v === 0 ? '—' : `$${Number(v).toLocaleString()}`;
export const fmtBool = (v: boolean): string => (v ? 'Yes' : 'No');
export const contactName = (c: {
  prefix?: string | null;
  first_name?: string | null;
  last_name?: string | null;
}): string => [c.prefix, c.first_name, c.last_name].filter(Boolean).join(' ') || '(no name)';
